import request from '../utils/request'

export function info(params) { // 考试活动详情
  return request({
    url: '/api/signup/info',
    method: 'GET',
    params
  })
}

export function banner(params) { // 考试活动轮播
  return request({
    url: '/api/signup/lunboo',
    method: 'GET',
    params
  })
}

export function searchRecord(params) { // 考试成绩查询
  return request({
    url: '/api/signup/info/record',
    method: 'GET',
    params
  })
}
